import {HTTPService, JsonResultClass} from "../../core/util/httpManager";
import {NotificationHelper} from "../../core/util/notificationHelper";
import {Helper} from "../../core/util/helper";
import {Config} from "../../core/config/config";
import {ToolBarStandardButton, ToolBarStandardButtonType} from "../../core/components/toolBar";
import {Grid} from "../../core/components/grid";
import {General} from "../../../siteManagement/general";
import {SheetEventType} from "../../../siteManagement/sheet";
import {AppBaseProps, CommonApp, Context, Entity} from "../../core/components/commonApp";
import {AppHelper} from "../../appHelper";
import {DialogHelper} from "../../core/util/dialogHelper";
import { EventType } from "../../../siteManagement/eventManager";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class EditSchemas extends React.Component<any, EditSchemasState>{
    private gridOptions: kendo.ui.GridOptions;
    private translations: StringKeyDictionary<string>;
    private initalized :boolean = false;
    constructor(props) {
        super(props);
        this.state = {
            gridData: []
        }
        this.translations = props.context.translations;
        this.initApp();
    }

    private initApp = async () => {
        try {
            const results = await Promise.all([this.getGridData()]);
            this.gridOptions = {
                sortable: true,
                pageable: true,
                groupable: false,
                filterable: false,
                selectable: true,
                resizable: true,
                scrollable: true,
                columns: [
                    {
                        field: "Displayname",
                        title: this.translations["Standard.Designation"]
                    }
                ]
            };
            this.initalized = true;
            this.setState({ gridData: results[0] })
        } catch (ex) {
            console.error(ex.message)
        }
    }


    private getGridData = (): Promise<any[]> => {
        return new Promise<any[]>(async (resolve, reject) => {
            const data = await HTTPService.get<any[]>("TimeType/GetAllSchemas")
            resolve(data);
        })
    }

    private reloadGridData = async () => {
        const data = await this.getGridData();
        this.setState({ gridData: data });
    }

    private createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [
            {

                caption: Config.translations.newLabel,
                enabled: true,
                type: ToolBarStandardButtonType.NEW
            },
            {
                caption: Config.translations.editLabel,
                enabled: true,
                type: ToolBarStandardButtonType.EDIT
            },
            {
                caption: Config.translations.deleteLabel,
                enabled: true,
                type: ToolBarStandardButtonType.DELETE
            }
        ];
       
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="editSchema"
                    standardButtons={standardButtons}
                    onClickStandardButton={this.onStandardClick}
                />
            </div>
        );
    }

    private onStandardClick = (type: ToolBarStandardButtonType, dataItem:any) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this.openSheet(dataItem.Id);
                break;
            case ToolBarStandardButtonType.NEW:
                this.openSheet();
                break;
            case ToolBarStandardButtonType.DELETE:
                this.delete(dataItem.Id).then(() => {
                    this.reloadGridData();
                });
                break;
        }
    }

    private openSheet = async (id: string = null) => {
        let url = "TimeType/GetSchemasById";
        if (!Helper.isNullOrEmpty(id)) {
            url += `?id=${id}`;
        }
        url = encodeURI(url);
        let results = await Promise.all([HTTPService.get<JsonResultClass<SchemaEntity>>(url), Helper.getMetaData("timeTypeSchema")]);
        if (results[0].Code == 0) {
            const props: SchemaProps = {
                context: {
                    contextType: "timeTypeSchema"
                },
                dataSources: null,
                entity: results[0].Data,
                isWindow: false,
                metadata: results[1],
                title: "",
                delete: this.delete
            }
            const sheet = General.Sheet.Manager.createSheet();
            sheet.bind(SheetEventType.Close, this.reloadGridData);
            sheet.show(() => {
                sheet.mountContent(Schema, props);
            });
            
        } else {
            NotificationHelper.showErrorMessage(results[0].Message);
        }
    }

    private delete = async (id: string) => {
        const isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            const result = await HTTPService.get<JsonResultClass>(`TimeType/DeleteSchema?id=${id}`);
            if (result.Code == 1) {
                NotificationHelper.showErrorMessage(result.Message);
            }
            return (result.Code == 0);
        } else {
            return false;
        }
    }

    render() {
        const grid = this.initalized ? this.createGrid() : null;
        return grid;
    }

}

interface EditSchemasState {
    gridData: KeyValuePair<string, string>[];
}
class Schema extends React.Component<SchemaProps, any>{
    common = new AppHelper();
    translations: StringKeyDictionary<string>;
    constructor(props: any) {
        super(props);
        this.common.init(this);
        this.props.context.translations = this.translations;
    }
    
    save = async () => {
        if (this.common.validate()) {
            let result = await HTTPService.post<JsonResultClass<SchemaEntity>>("TimeType/SaveSchema", { model: this.props.entity });
            if (result.Code == 0) {
                Helper.updateEntity(this.props.entity, result.Data);
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            General.Events.trigger(EventType.Custom, { cmd: "reloadTypes" });
            this.common.handlePostSave(result.Code == 0, false);
        }
    }

    deleteSchema = async () => {
        const isDeleted = await this.props.delete(this.props.entity.Id);
        if (isDeleted) {
            General.Sheet.Manager.getTopMostSheet().hide();
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <><CommonApp {...props} /></>;
    }
}


interface SchemaProps extends AppBaseProps {
    entity: SchemaEntity;
    context: SchemaContext;
    delete: (id: string) => Promise<boolean>;
}

interface SchemaContext extends Context{
    translations?: StringKeyDictionary<string>;
}

interface SchemaEntity extends Entity {
    Id: string;
    Name: number;
    Content: KeyValuePair<string, string>;
}